import { DateTime, Interval } from 'luxon';
import { Event, EventState } from '../generated/types';
import { DateTimeService } from '../services/dateTimeService';
import { assertUnreachable } from '../util/assertUnreachable';
import { Emptyable } from '../util/emptyable';
import { LocaleFormats } from '../util/luxon';
import { ICoordinates, IGoogleCoordinates } from '../util/map';

export function getGoogleCenter(
    event: Emptyable<Pick<Event, 'latitude' | 'longitude'>>
): IGoogleCoordinates | undefined {
    if (typeof event?.latitude === 'number' && typeof event?.longitude === 'number') {
        return {
            lat: event.latitude,
            lng: event.longitude
        };
    } else {
        return undefined;
    }
}

export function getCenter(
    event: Emptyable<Pick<Event, 'latitude' | 'longitude'>>
): ICoordinates | undefined {
    if (typeof event?.latitude === 'number' && typeof event?.longitude === 'number') {
        return {
            latitude: event.latitude,
            longitude: event.longitude
        };
    } else {
        return undefined;
    }
}

export function startAtEndAtToString(
    dateTimeService: DateTimeService,
    startAt: DateTime,
    endAt: DateTime
): string {
    const format = LocaleFormats.DateOnly.MonthLong;

    if (startAt.equals(endAt)) {
        return dateTimeService.toLocaleString(startAt, format);
    } else {
        return [
            dateTimeService.toLocaleString(startAt, LocaleFormats.DateOnly.MonthShort),
            dateTimeService.toLocaleString(endAt, LocaleFormats.DateOnly.MonthShort)
        ].join(' - ');
    }
}

export function getStateColor(state: EventState) {
    switch (state) {
        case EventState.Archived:
        case EventState.Done:
            return 'error';
        case EventState.Ongoing:
            return 'success';
        case EventState.Upcoming:
            return 'purple';
        default:
            return assertUnreachable(state);
    }
}

export function getState(event: Event): EventState {
    if (event.deletedAt) {
        return EventState.Archived;
    } else if (
        Interval.fromDateTimes(event.startAt.startOf('day'), event.endAt.endOf('day')).contains(
            DateTime.utc()
        )
    ) {
        return EventState.Ongoing;
    } else if (event.endAt >= DateTime.utc().startOf('day')) {
        return EventState.Upcoming;
    } else {
        return EventState.Done;
    }
}

export function getCalendarFilterStartDate(startAt: DateTime, endAt: DateTime) {
    const now = DateTime.now().setZone('utc', { keepLocalTime: true }).startOf('day');

    return Interval.fromDateTimes(startAt.startOf('day'), endAt.endOf('day')).contains(now)
        ? now
        : startAt;
}
